import { createNode } from '@glueapp/graph-types';

export const Maximum = createNode({
    id: 'Maximum',
    name: 'Maximum',
    description: 'Gives the maximum of the two numbers',
    aiDescription:
        'Returns the larger of two numbers. Connect values to "Number1" and "Number2" input ports; the "Result" output port provides the maximum.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number1: {
            kind: 'number',
        },
        Number2: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.max(input.inPorts.Number1, input.inPorts.Number2) } };
    },
});
